"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e=(t=>(t.TextInfoSection="text-info-section",t.TextInfoSectionCta="text-info-section-cta-button",t))(e||{});exports.TextInfoDataTestIds=e;
